import Dropdown from 'flarum/common/components/Dropdown';

function getNtosVirtualKeys() {
    return [
        { name: 'LMOUSE', id: 1 }, { name: 'RMOUSE', id: 2 }, { name: 'MMOUSE', id: 4 }, { name: 'XMOUSE1', id: 5 }, { name: 'XMOUSE2', id: 6 },

        { name: 'ENTER', id: 13 }, { name: 'LSHIFT', id: 160 }, { name: 'RSHIFT', id: 161 }, { name: 'LALT', id: 164 }, { name: 'RALT', id: 165 }, { name: 'SPACE', id: 32 }, { name: 'END', id: 35 }, { name: 'INSERT', id: 45 }, { name: 'HOME', id: 36 }, { name: 'DELETE', id: 46 }, { name: 'ESC', id: 27 }, { name: 'CAPSLOCK', id: 20 }, { name: 'NUMLOCK', id: 144 }, { name: 'BACKSPACE', id: 8 }, { name: 'TAB', id: 9 }, { name: 'LCTRL', id: 162 }, { name: 'RCTRL', id: 163 },

        { name: 'A', id: 65 }, { name: 'B', id: 66 }, { name: 'C', id: 67 }, { name: 'D', id: 68 }, { name: 'E', id: 69 }, { name: 'F', id: 70 }, { name: 'G', id: 71 }, { name: 'H', id: 72 }, { name: 'I', id: 73 }, { name: 'J', id: 74 }, { name: 'K', id: 75 }, { name: 'L', id: 76 }, { name: 'M', id: 77 }, { name: 'N', id: 78 }, { name: 'O', id: 79 }, { name: 'P', id: 80 }, { name: 'Q', id: 81 }, { name: 'R', id: 82 }, { name: 'S', id: 83 }, { name: 'T', id: 84 }, { name: 'U', id: 85 }, { name: 'V', id: 86 }, { name: 'W', id: 87 }, { name: 'X', id: 88 }, { name: 'Y', id: 89 }, { name: 'Z', id: 90 },

        { name: '0', id: 48 }, { name: '1', id: 49 }, { name: '2', id: 50 }, { name: '3', id: 51 }, { name: '4', id: 52 }, { name: '5', id: 53 }, { name: '6', id: 54 }, { name: '7', id: 55 }, { name: '8', id: 56 }, { name: '9', id: 57 },

        { name: 'F1', id: 112 }, { name: 'F2', id: 113 }, { name: 'F3', id: 114 }, { name: 'F4', id: 115 }, { name: 'F5', id: 116 }, { name: 'F6', id: 117 }, { name: 'F7', id: 118 }, { name: 'F8', id: 119 }, { name: 'F9', id: 120 }, { name: 'F10', id: 121 }, { name: 'F11', id: 122 }, { name: 'F12', id: 123 },
    ];
}

export default class Keyselect extends Dropdown
{
    static initAttrs(attrs) {
        super.initAttrs(attrs);

        attrs.lazyDraw ||= true;
        attrs.label ||= getNtosVirtualKeys().find((key) => key.id == attrs.keyid)?.name;
    }

    view(vnode) {
        getNtosVirtualKeys().map((key) => vnode.children.push(<a onclick={this.onchange.bind(this, key.id, key.name)}>{key.name}</a>));

        return super.view(vnode);
    }

    onchange(value) {
        if (this.attrs.onchange) this.attrs.onchange(value);
    }
}
